import React from 'react';
import styled from 'styled-components';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import { useDispatch } from 'react-redux';
import screenerSlice from 'features/screener/slice';

const SHeaderTopContainerButton = styled.div`
  position: relative;
  display: flex;
  gap: 10px;
`;

const SButton = styled(Button)`
  :hover {
    color: ${color.primary};
    background: ${color.aliceBlue};
  }
`;

const ScreenerButton = () => {
  const dispatch = useDispatch();

  const {
    actions: {
      setIsFormActive,
      setIsFormCreateMode,
      setIsModalPresetScreenerActive,
      setIsFormEditMode,
      resetFormState,
    },
  } = screenerSlice;

  const createNewScreenerHandler = () => {
    dispatch(resetFormState());
    dispatch(setIsFormActive(true));
    dispatch(setIsFormCreateMode(true));
    dispatch(setIsFormEditMode(false));
  };

  const showPresetScreenerHandler = () => {
    dispatch(setIsModalPresetScreenerActive(true));
  };

  return (
    <SHeaderTopContainerButton>
      <Button type="primary" onClick={createNewScreenerHandler}>
        Create New
      </Button>
      <SButton onClick={showPresetScreenerHandler}>Preset Screener</SButton>
    </SHeaderTopContainerButton>
  );
};

export default ScreenerButton;
